import { render } from "./Beranda.vue?vue&type=template&id=d7a653d8&ts=true"
import script from "./Beranda.vue?vue&type=script&lang=ts"
export * from "./Beranda.vue?vue&type=script&lang=ts"

import exportComponent from "/home/dajetmiko/react/admin.animemo.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__